const BADGE_STYLES = {
  "under-valued": {
    className: "border border-emerald-300/80 bg-[linear-gradient(135deg,#effcf4_0%,#dff7ea_100%)] text-emerald-800 shadow-[0_10px_24px_rgba(16,185,129,0.12)]",
    compactLabel: "UNDER-VALUED",
  },
  "fair-entry": {
    className: "border border-slate-300/90 bg-[linear-gradient(135deg,#ffffff_0%,#f3f4f6_100%)] text-slate-800 shadow-[0_10px_24px_rgba(15,23,42,0.08)]",
    compactLabel: "FAIR ENTRY",
  },
  "premium-justified": {
    className: "border border-slate-400/70 bg-[linear-gradient(135deg,#001935_0%,#23344c_100%)] text-slate-100 shadow-[0_12px_28px_rgba(0,25,53,0.22)]",
    compactLabel: "PREMIUM JUSTIFIED",
  },
};

const splitBadgeLabel = (label = "") => {
  const trimmed = String(label || "").trim();
  const match = trimmed.match(/^(\p{Emoji_Presentation}|\p{Extended_Pictographic})\s*(.*)$/u);
  if (!match) return { emoji: "", text: trimmed };
  return { emoji: match[1], text: match[2] || trimmed };
};

export const getInvestmentBadgePresentation = ({ investment_badge_label, investment_badge_tone }) => {
  if (!investment_badge_label || !investment_badge_tone) return null;
  const config = BADGE_STYLES[investment_badge_tone];
  if (!config) return null;
  const { emoji, text } = splitBadgeLabel(investment_badge_label);
  return {
    label: investment_badge_label,
    emoji,
    text: text || investment_badge_label,
    compactLabel: config.compactLabel,
    className: config.className,
  };
};